/**
 * Dev-only Vue Router routes that MUST NOT ship to production (TD-01 / decisions-log Q36).
 *
 * The /dev/component-playground route renders an internal component demo
 * (AppButton / AppInput / AppToggle ...) used for PO-BA / Leader review — it is not a
 * product screen. Per Q36 it is gated on NODE_ENV instead of `requiresAuth`: in a
 * production build webpack DefinePlugin statically replaces `process.env.NODE_ENV` with
 * "production", so `buildDevRoutes("production", ...)` returns [] and the route is never
 * registered — navigating to /dev/component-playground then falls through to the "*" 404
 * route. `requiresAuth` was rejected (Q36) because it would still register the route and
 * still show the page to any logged-in production user.
 *
 * CommonJS (module.exports) so both webpack (`import { buildDevRoutes } from
 * "@/utils/devRoutes"`) and node:test (`require("../../src/utils/devRoutes")`) resolve
 * the same module — matches src/utils/surveyExam.js / orgFilter.js. `loadView` is
 * injected (not imported) to keep this module free of Vue and the "@" webpack alias so
 * it stays unit-testable (see test/unit/router-guard.spec.js).
 *
 * NOTE: this guard removes the ROUTE REGISTRATION only. The compiled
 * pages/dev/component-playground.vue chunk is still emitted by webpack, because router's
 * `loadView` uses a dynamic `import(`@/pages/${rootPath}${view}.vue`)` whose recursive
 * context module includes every .vue under src/pages. Not registering the route is what
 * makes the page unreachable (404); the leftover lazy chunk is unreferenced and inert.
 *
 * @param {string|undefined} env - build-time process.env.NODE_ENV
 * @param {(view: string, rootPath?: string) => unknown} loadView - router lazy loader
 * @returns {Array<{path: string, component: unknown}>} dev-only routes ([] in production)
 */
function buildDevRoutes(env, loadView) {
  if (env === "production") return [];
  return [
    {
      path: "/dev/component-playground",
      component: loadView("component-playground", "dev/"),
    },
  ];
}

module.exports = { buildDevRoutes };
